var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0711 3.07107C13.166 -0.834047 6.83405 -0.834047 2.92893 3.07107C-0.976183 6.97618 -0.976183 13.3081 2.92893 17.2132C6.83405 21.1183 13.166 21.1183 17.0711 17.2132C20.9762 13.3081 20.9762 6.97618 17.0711 3.07107ZM11.6117 10.9548L7.20528 15.3613L4.78085 12.9369L9.1873 8.5304L6.62828 5.97138L14.0069 6.1352L14.1708 13.5139L11.6117 10.9548Z",
    fill: "black",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlack);
export default __webpack_public_path__ + "static/media/arrowBlack.06b4a3b75d71336cf6c2b3b62e97d239.svg";
export { ForwardRef as ReactComponent };